export interface PageTagProfile {
  id?: string
  language: string
  name?: string
}

export interface PageTagFormValues {
  page_tag_profiles: PageTagProfile[]
  slug: string
}

export interface PageTag {
  id: number
  slug?: string | null
  page_tag_profiles: { id: string; language: string; name: string }[]
}

export function getTagName(tag: PageTag, language: string): string {
  return (
    tag.page_tag_profiles.find(
      p => p.language.toLowerCase() === language.toLowerCase()
    )?.name ||
    tag.page_tag_profiles[0]?.name ||
    `Tag #${tag.id}`
  )
}
